import React from "react";
import PageShell from "@/components/PageShell";
import PageHeader from "@/components/PageHeader";
import VantageBenefits from "@/components/sections/VantageBenefits";
import Ticker from "@/components/sections/Ticker";
import CTASection from "@/components/CTASection";

export default function VantagePage() {
    return (
        <PageShell>
            <div data-testid="vantage-page">
                <PageHeader
                    eyebrow="Why Vantage Markets"
                    title="A broker built on"
                    accent="precision, regulation, and reach."
                    subtitle="Vantage Markets serves over 1.2 million traders across 50+ countries with institutional-grade infrastructure, multi-jurisdiction licensing, and platform choice. Here's why we partner with them — and only them."
                    breadcrumbs={[{ label: "Vantage Markets" }]}
                />
                <Ticker />
                <VantageBenefits />
                <CTASection
                    eyebrow="Get Started"
                    title="Open your Vantage account with"
                    accent="a guided walkthrough."
                    subtitle="No paperwork left to guess at. We talk through account types, KYC, deposits and platform setup live."
                />
            </div>
        </PageShell>
    );
}
